import Pidgin from '@lessonnine/pidgin.js';
import { Translator } from '@lessonnine/pidgin.js/@types';

import { LOCALE } from 'src/dataLayer/env';
import { Translation, NamespaceTranslator } from 'src/types/translations';

const TRANSLATION_LOCALES = {
  de: 'de',
  en: 'en',
  en_GB: 'en-GB',
  es: 'es',
  fr: 'fr',
  it: 'it',
  pl: 'pl',
  pt: 'pt',
  sv: 'sv',
  uk: 'uk'
};
const translationLanguage = TRANSLATION_LOCALES[LOCALE as keyof typeof TRANSLATION_LOCALES];
/*
eslint-disable-next-line import/no-dynamic-require, @typescript-eslint/no-var-requires,
unicorn/prefer-module, @typescript-eslint/no-unsafe-assignment -- we need to require the json file here
*/
const translations: Translation = require(`src/viewLayer/assets/locales/${translationLanguage}.json`);
type CurrentLocaleTranslations = {[key: string] : Translation};
const currentLocales : CurrentLocaleTranslations = {
  [LOCALE]: translations
};

const pidgin = new Pidgin({
  locale: LOCALE,
  locales: currentLocales,
  onMissingKey: (): void => {}
});

export const t: Translator = (...arguments_) =>
  pidgin.t(...arguments_);

export const namespaceT: NamespaceTranslator = (namespace) =>
  pidgin.namespace(namespace);
